import React from 'react';
import {makeStyles, Tab, Tabs, useMediaQuery,} from "@material-ui/core";
import {RewardsCard} from "./RewardsCard";
import {BP_LARGE} from "Theme/breakpoints";
import {LockIcon, TickIcon, UnlockIcon} from "Components/CustomIcons";

export const useRewardsTabStyles = makeStyles(theme => {
    const RewardsPageSettings = theme.overrides.RewardsPage;

    return {
        root: {
            position: 'relative',
            // background: RewardsPageSettings.background,
            '& .MuiTabs-indicator': {
                height: '100%',
                borderRadius: RewardsPageSettings.indicator.borderRadius,
                backgroundColor: RewardsPageSettings.indicator.background,
            },
            '& .MuiTab-textColorPrimary': {
                color: theme.palette.layout.contrastText,
            },
            '& .MuiTabs-root': {
                margin: '1rem 0',
                height: 40,
                minHeight: 40,
                overflow: 'initial',
                [theme.breakpoints.up(BP_LARGE)]: {
                    margin: '2rem 0 1.75rem 0',
                }

            },
            '& .MuiTab-root': {
                color: RewardsPageSettings.tabs.inactiveColor,
                zIndex: 1,
                padding: '0 10px',
                minWidth: 'auto',
                [theme.breakpoints.up(BP_LARGE)]: {
                    fontSize: '1.25rem',
                    padding: '0 40px',
                },
                '&.Mui-selected': {
                    color: RewardsPageSettings.tabs.activeColor,
                }
            },
            '& .MuiTab-wrapper': {
                flexDirection: "row",
                alignItems: "center",
                textTransform: 'none',
                '& > .MuiSvgIcon-root': {
                    marginRight: 0,
                    marginBottom: 0,
                },
                [theme.breakpoints.up(BP_LARGE)]: {
                    alignItems: "self-end",
                    '& > .MuiSvgIcon-root': {
                        marginBottom: 6,
                    }
                },

            },
            '& .MuiTab-labelIcon': {
                minHeight: 40,
            },

        },
        centerColumn: {
            margin: "5rem auto",
        },
        isLocked: {
            display: 'none',
            [theme.breakpoints.up(BP_LARGE)]: {
                display: 'block',
                position: 'absolute',
                top: 0,
                left: 0,
                width: 100,
                height: 100,
                background: `linear-gradient(to right bottom, #8C898D 49%, transparent 50%)`,
                padding: 15,
                '& .MuiSvgIcon-root': {
                    width: '1.5em',
                    height: '1.5em',
                }
            }
        },
        box: {
            [theme.breakpoints.down(BP_LARGE)]: {
                margin: '40px 0',
            },
            [theme.breakpoints.up(BP_LARGE)]: {
                margin: '80px 0'
            }
        },
    }
});

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div>
            {value === index && (
                <div className="row align-center">{children}</div>
            )}
        </div>
    );
}

const REWARDS_TABS = [...Array(5).keys()];

export const RewardsTab = (props) => {
    const classes = useRewardsTabStyles();
    const matchesLargeUp = useMediaQuery('(min-width:600px)');
    const currentLevel = props.currentLevel - 1;
    const [activeTab, setActiveTab] = React.useState(currentLevel);
    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <div className={`columns small-12 ${classes.root}`}>
            <Tabs
                value={activeTab}
                onChange={handleChange}
                centered
            >
                {REWARDS_TABS.map((i) =>
                    <Tab
                        key={`tab-${i}`}
                        disableRipple
                        icon={currentLevel > i ? <TickIcon size={5}/> : currentLevel === i ? <UnlockIcon/> : <LockIcon/>}
                        label={`${matchesLargeUp ? 'Level ' : 'L'}${i + 1}`}
                    />
                )}
            </Tabs>

            {REWARDS_TABS.map((i) =>
                <TabPanel value={activeTab} index={i} key={`panel-${i}`}>
                    {currentLevel < i &&
                        <div className={classes.isLocked}>
                            <LockIcon/>
                        </div>
                    }
                    {props.promotions.filter(p => p.internalName.includes(`REWARDS_LEVEL_${i + 1}`)).map((promo, key) => (
                        <RewardsCard
                            key={key}
                            title={promo.displayName}
                            desc={promo.description}
                            image={promo.images.default.url}
                            promoId={promo.id}
                        />
                    ))}
                </TabPanel>
            )}
        </div>
    );
}
